import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import SEO from "../components/SEO";
import { faqItems, businessInfo } from "../data/content";
import { getFaqJsonLd, getBreadcrumbJsonLd } from "../data/jsonld";

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <>
      <SEO
        title="FAQ - Questions fréquentes | Plombier à Meaux (77) | Pereira Plomberie"
        description="Réponses aux questions les plus fréquentes sur nos services de plomberie et chauffage à Meaux. Urgences, devis, délais, zones d'intervention."
        jsonLd={[
          getFaqJsonLd(faqItems),
          getBreadcrumbJsonLd([{ name: "Accueil", url: "/" }, { name: "FAQ" }]),
        ]}
      />

      <section className="bg-primary text-white py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-sm font-accent font-medium tracking-widest text-secondary uppercase mb-2">Aide</p>
          <h1 className="font-heading text-4xl md:text-6xl font-bold uppercase tracking-tight" data-testid="faq-title">
            Questions fréquentes
          </h1>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-3">
            {faqItems.map((item, i) => (
              <div key={i} className="bg-white border border-slate-200 rounded-sm overflow-hidden" data-testid={`faq-item-${i}`}>
                <button
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                  className="w-full flex items-center justify-between p-5 text-left hover:bg-slate-50 transition-colors"
                  data-testid={`faq-toggle-${i}`}
                  aria-expanded={openIndex === i}
                >
                  <span className="font-medium text-sm pr-4">{item.question}</span>
                  <ChevronDown
                    size={18}
                    className={`flex-shrink-0 text-secondary transition-transform ${openIndex === i ? "rotate-180" : ""}`}
                  />
                </button>
                {openIndex === i && (
                  <div className="px-5 pb-5 text-sm text-slate-600 leading-relaxed border-t border-slate-100 pt-3" data-testid={`faq-answer-${i}`}>
                    {item.answer}
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="mt-12 text-center p-8 bg-secondary/5 rounded-sm border border-secondary/20">
            <h2 className="font-heading text-xl font-bold uppercase tracking-tight mb-2">Vous avez une autre question ?</h2>
            <p className="text-slate-600 text-sm mb-4">N'hésitez pas à nous contacter directement.</p>
            <a
              href={businessInfo.phoneTel}
              className="inline-flex items-center gap-2 bg-secondary hover:bg-secondary/90 text-white font-bold uppercase tracking-wider py-3 px-6 rounded-sm text-sm transition-all"
              data-testid="faq-cta-phone"
            >
              {businessInfo.phone}
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
